<template>
  <div class="content-wrap">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' v-on:getSearchObj='getSearchObj' />
    </div>
    <!-- 平台表格 -->
    <BaseTable style="background-color: #fff; padding: 20px; margin: 0 17px" :data="tableData" :column="tabListLConfig"
      pagination :auto-scroll="true" :total="totalPage" :page.sync="searchParams.current"
      @selection-change="selectionChange" :limit.sync="searchParams.size" @pagination="init">
    </BaseTable>
    <!-- 退款弹窗 -->
    <el-dialog title="退款" class="refundDialog" @close='closeRefund' destroy-on-close :visible.sync="showRefund"
      :close-on-click-modal="false" width="30%" center>
      <el-form status-icon label-width="80px" ref="refundRef" :model="refund" :rules="refundRules" size="small">
        <el-form-item label="退款金额" prop="refundMoney">
          <el-input v-model="refund.refundMoney" placeholder="请输入退款金额"></el-input>
        </el-form-item>
        <el-form-item label="退款说明" prop="refundText">
          <el-input type="textarea" v-model="refund.refundText" placeholder="请输入退款说明"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button slot="reference" type="primary" @click="submitHandel">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗信息 -->
    <el-dialog title="订单详情" :visible.sync="drawerFlag" width="50%" top="5vh" center :close-on-click-modal="false">
      <div style="height: 75vh">
        <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
          <el-form label-position="left" label-width="100px" label-suffix="：" size="small">
            <div class="header">
              <p></p>
              <h1>商品信息</h1>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="订单编号">
                  <span>{{ orderDetails.orderNo ? orderDetails.orderNo : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单状态">
                  <span>{{ orderDetails.paymentState | payStatus }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="病人">
                  <span>{{ orderDetails.patientName ? orderDetails.patientName : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="问诊状态">
                  <span>{{ orderDetails.status | consultationStatus }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <!-- 11111 -->
                <el-form-item label="抵扣权益">
                  <span>{{ orderDetails.doctorName ? orderDetails.doctorName : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="问诊类型">
                  <span>{{ orderDetails.type === 'message' ? '图文协同' : orderDetails.type === 'video' ? '视频协同' : '--'
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发起人">
                  <span>{{ orderDetails.fromDoctorName ? orderDetails.fromDoctorName : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发起人团队">
                  <span>{{ orderDetails.fromDoctorTeamName ? orderDetails.fromDoctorTeamName : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="协同人">
                  <span>{{ orderDetails.admissionDoctorName ? orderDetails.admissionDoctorName : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="协同团队">
                  <span>{{ orderDetails.admissionDoctorTeamName ? orderDetails.admissionDoctorTeamName : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="创建时间">
                  <span>{{ orderDetails.createOrderTime ? orderDetails.createOrderTime : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="header">
              <p></p>
              <h1>订单信息</h1>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="订单创建人">
                  <span>{{ orderDetails.createUserName ? orderDetails.createUserName : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单付款人">
                  <span>{{ orderDetails.payUserName ? orderDetails.payUserName : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="协同价格">
                  <span>{{ orderDetails.amountOriginal | money }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="优惠金额">
                  <span v-if="orderDetails.discountAmount">{{ orderDetails.discountAmount | money }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="应付金额">
                  <span v-if="orderDetails.amountPayable">{{ orderDetails.amountPayable | money }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实付金额">
                  <span v-if="orderDetails.payAmount">{{ orderDetails.payAmount | money }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="支付方式">
                  <span>{{ orderDetails.paymentMethod | filterPay }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付时间">
                  <span>{{ orderDetails.payTime ? orderDetails.payTime : '--' }}</span>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="服务开始时间">
                  <span>{{ orderDetails.startTime ? orderDetails.startTime : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务结束时间">
                  <span>{{ orderDetails.endTime ? orderDetails.endTime : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="header">
              <p></p>
              <h1>退款信息</h1>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="退款人">
                  <span>{{ orderDetails.refundUserName ? orderDetails.refundUserName : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="退款时间">
                  <span>{{ orderDetails.refundTime ? orderDetails.refundTime : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="退款金额">
                  <span>{{ orderDetails.refundMoney | money }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="退款说明">
                  <span>{{ orderDetails.refundText ? orderDetails.refundText : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSynergyOrderPage,
  getSynergyOrderDetails,
  getServiceByType,
  reminder,
  prescriptionRefund
} from "./api/orderPay";
export default {
  data() {
    var checkMoney = (rule, value, callback) => {
      if (!value || value == 0) {
        return callback(new Error("金额不能为空"));
      }
      setTimeout(() => {
        var regex = /^[0-9]+(\.[0-9]{1,2})?$/;
        if (!regex.test(value)) {
          callback(new Error("请输入正确的金额"));
        } else {
          if (value > this.scopeItme.payAmount) {
            callback(new Error("退款金额不可大于实付金额"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return {
      breadList: [{ name: "订单管理" }, { name: "协同订单" }],
      searchList: [
        {
          label: "订单编号",
          value: 8,
          paramName: "orderNo",
          inputType: "input"
        },
        {
          label: "用户名或微信名",
          value: 1,
          paramName: "patientName",
          inputType: "input",
          maxLength: 5
        },
        {
          label: "订单状态",
          value: 3,
          paramName: "paymentState",
          inputType: "select",
          optionData: []
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      scopeItme: "", //
      serviceTypeList: [],
      showRefund: false, //退款弹窗开关
      activeName: "", //标签页选中
      totalPage: 0,
      refund: {
        refundMoney: "", //退款金额
        refundText: "" //退款说明
      },
      refundRules: {
        refundMoney: [
          {
            validator: checkMoney,
            trigger: "blur",
            required: true
          }
        ],
        refundText: [
          {
            required: true,
            message: "请输入退款原因",
            trigger: "blur"
          }
        ]
      },
      tableData: [],
      tabListLConfig: [
        {
          label: "序号",
          align: "center",
          fixed: "left",
          prop: "date",
          size: "mini",
          width: "50px",
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>;
          }
        },
        {
          label: "订单编号",
          align: "center",
          prop: "orderNo",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "协同目的",
          align: "center",
          prop: "title",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "发起人所属机构",
          align: "center",
          prop: "fromHospitalName",
          width: '135px'
        },
        {
          label: "发起人所属科室",
          align: "center",
          prop: "fromDoctorDepartmentName", // 无字段 
          showOverflowTooltip: true,
          width: '135px'
        },
        {
          label: "协同发起人",
          align: "center",
          prop: "fromDoctorName",
          width: '110px',
          showOverflowTooltip: true
        },
        {
          label: "协同所属机构",
          align: "center",
          prop: "admissionHospitalName",
          showOverflowTooltip: true,
          width: '135px'
        },
        {
          label: "协同所属科室",
          align: "center",
          prop: "admissionDoctorDepartmentName",
          width: '135px'
        },
        {
          label: "协同人", // 接诊医生
          align: "center",
          prop: "admissionDoctorName",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "协同团队",
          align: "center",
          prop: "admissionDoctorTeamName",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "患者姓名",
          align: "center",
          prop: "patientName",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "协同时间",
          align: "center",
          prop: "startTime",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "协同价格",
          align: "center",
          prop: "amountOriginal",
          size: "mini"
        },
        {
          label: "优惠",
          align: "center",
          prop: "discountAmount", // 原价-应付金额 amountPayable
          size: "mini"
        },
        {
          label: "实付金额",
          align: "center",
          prop: "payAmount",
          size: "mini"
        },
        {
          label: "创建时间",
          align: "center",
          prop: "createOrderTime",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "支付方式",
          align: "center",
          prop: "paymentMethod",
          size: "mini",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.commodityType === 6 &&
                  scope.row.specCurrentPrice === 0
                  ? "商品赠送"
                  : this.handelPay(scope.row.paymentMethod)}
              </span>
            );
          }
        },
        {
          label: "支付时间",
          align: "center",
          prop: "payTime",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "退款人",
          align: "center",
          size: "mini",
          showOverflowTooltip: true,
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.paymentState == 4 ? scope.row.refundUserName : ""}
              </span>
            );
          }
        },
        {
          label: "退款金额",
          align: "center",
          size: "mini",
          prop: "refundMoney"
        },
        {
          label: "退款备注",
          align: "center",
          size: "mini",
          prop: "refundText",
          showOverflowTooltip: true
        },
        {
          label: "退款时间",
          align: "center",
          prop: "refundTime",
          size: "mini",
          showOverflowTooltip: true
        },
        {
          label: "订单状态",
          align: "center",
          size: "mini",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.paymentState == 1
                  ? "待支付"
                  : scope.row.paymentState == 2
                    ? "已支付"
                    : scope.row.paymentState == 3
                      ? "已取消"
                      : scope.row.paymentState == 4
                        ? "已退款"
                        : scope.row.paymentState == 7
                          ? "已完成"
                          : scope.row.paymentState == 8
                            ? "待退款"
                            : "未知"}
              </span>
            );
          }
        },
        {
          label: "操作",
          align: "center",
          fixed: "right",
          width: "150px",
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: { type: "text", size: "mini" },
                  on: {
                    click: () => {
                      this.hometHandel(scope, "details");
                    }
                  }
                },
                "详情"
              ),

              h(
                "el-button",
                {
                  props: { type: "text", size: "mini" },
                  attrs: {
                    disabled:
                      scope.row.paymentState == 2 || scope.row.paymentState == 8 || scope.row.paymentState == 7
                        ? false
                        : true
                  },
                  on: {
                    click: () => {
                      this.hometRefundHandel(scope.row);
                    }
                  }
                },
                scope.row.payAmount == 0 ||
                  (scope.row.commodityType === 6 &&
                    scope.row.specCurrentPrice === 0)
                  ? ""
                  : scope.row.paymentState == 4
                    ? "已退款"
                    : "退款"
              )
            ]);
          }
        }
      ],
      drawerFlag: false,
      orderType: "", //1, "方案/全病程 2, "药品" 3, "问诊"
      orderDetails: {
        orderDrugDetailVO: {},
        doctorVO: {},
        orderInfoVO: {},
        orderInquiryDetailVO: {},
        orderPayVO: {},
        wholeCourseVO: {},
        elecPrescriptionVO: {}
      }, //订单详情
      popupActiveName: "first"
    };
  },
  created() {
    this.searchList[2].optionData = this.$defaultData.orderPayStatus;
    this.init();
    this.getServiceByTypeHandel();
  },
  methods: {
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.init();
    },
    closeRefund() {
      this.$refs["refundRef"].resetFields();
    },
    submitHandel() {
      this.$refs["refundRef"].validate(valid => {
        if (valid) {
          prescriptionRefund({
            ...this.refund,
            orderId: this.scopeItme.id,
            orderDetailId: this.scopeItme.detailId
          }).then(res => {
            if (res.code == 0) {
              this.$message.success('退款成功！');
              this.scopeItme = "";
              this.refund = this.$options.data().refund;
              this.showRefund = false;
              this.init();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    submitRefundHandel() { },
    hometRefundHandel(scope) {
      this.showRefund = true;
      this.scopeItme = scope;
      this.refund.refundText = scope.refundText;
    },
    /**
     * @description: 根据类型获取问诊服务
     * @param {serviceType：1}
     * @return {*}
     */
    getServiceByTypeHandel() {
      getServiceByType({
        serviceType: 1
      }).then(res => {
        if (res.code == 0) {
          this.serviceTypeList = res.data;
        }
      });
    },
    selectionChange() { },
    hometHandel(scope, type) {
      this.orderType = scope.row.commodityType;
      if (type == "details") {
        getSynergyOrderDetails(scope.row.id).then(res => {
          if (res.code == 0) {
            this.orderDetails = res.data;
            this.drawerFlag = true;
          }
        });
      }
    },
    init() {
      this.searchParams.commodityType = 7;
      getSynergyOrderPage(this.searchParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records.map(item => {
            return {
              ...item,
              specCurrentPrice:
                item.specCurrentPrice | this.$options.filters.money,
              // discount:
              //   (item.specOriginalPrice - item.specCurrentPrice) |
              //   this.$options.filters.money
            };
          });
          this.totalPage = res.data.total;
        }
      });
    }
  },

  filters: {
    payStatus(key) {
      switch (key * 1) {
        case 1:
          return "待支付";
        case 2:
          return "已支付";
        case 3:
          return "已取消";
        case 4:
          return "已退款";
        case 7:
          return "已完成";
        case 8:
          return "待退款";
        default:
          return "未知";
      }
    },
    consultationStatus(key) {
      switch (key) {
        case "created":
          return "已创建";
        case "unpay":
          return "待支付";
        case "waiting":
          return "待接诊";
        case "ready":
          return "未开始";
        case "underway":
          return "进行中";
        case "ended":
          return "已结束";
        case "rejected":
          return "已退诊";
        case "canceled":
          return "已取消";
        default:
          return "未知";
      }
    },
    periodType(key) {
      switch (key * 1) {
        case 1:
          return "天";
        case 2:
          return "月";
        case 3:
          return "周";
        case 4:
          return "季";
        case 5:
          return "年";
        default:
          return key;
      }
    }
  }
};
</script>

<style>
.el-form-item__label {
  font-size: 12px !important;
}
</style>
<style lang="less" scoped>
@import "./order.less";
</style>
